import Icon from '../components/Icon.vue'

Icon.register({
  'won-sign': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M564 192C570.6 192 576 186.6 576 180V140C576 133.4 570.6 128 564 128H516L534.5 47.4C536.3 39.9 530.6 32.7 522.9 32.7H476.7A12-12 0 0 1 465 42.2L450.7 128H340.8L321.1 42A12-12 0 0 1 309.4 32.7H265.4A12-12 0 0 1 253.7 42L233.7 128H125L107.5 42.3A12-12 0 0 1 95.7 32.7H53.6C45.9 32.7 40.2 39.8 41.9 47.3L60 128H12C5.4 128 0 133.4 0 140V180C0 186.6 5.4 192 12 192H74.3L81.5 224H12C5.4 224 0 229.4 0 236V276C0 282.6 5.4 288 12 288H95.9L136.8 470.6A12-12 0 0 1 148.5 480H205.3C210.8 480 215.7 476.1 216.9 470.7L259.3 288H314.4L356.8 470.7A12-12 0 0 1 368.5 480H425.3A12-12 0 0 1 437 470.7L479.1 288H564C570.6 288 576 282.6 576 276V236C576 229.4 570.6 224 564 224H493.9L501.2 192H564zM138 192H218.8L211.3 224H144.5L138 192zM183.8 342C177.6 367.9 177.1 389.3 176.5 389.3H175.4S173.7 367.2 168.6 342L157.6 288H196.4L183.8 342zM274.2 224L276.2 215.4C278 207.4 279.6 199.4 281 192H292.8C294.1 199.4 295.7 207.4 297.6 215.4L299.6 224H274.2zM405.1 342C400.1 367.2 398.4 389.3 398.4 389.3H397.3C396.7 389.3 396.1 367.9 389.9 342L377.5 288H416.6L405.1 342zM430.3 224H362.9L355.5 192H437.1L430.3 224z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/won-sign.js
// module id = 4R5h
// module chunks = 144